import service_img_1 from "../../assets/images/services/services-1.jpg"
import service_img_2 from "../../assets/images/services/services-2.jpg"
import service_img_3 from "../../assets/images/services/services-3.jpg"
import service_img_4 from "../../assets/images/services/services-4.jpg"

export const servicesDataThree = [
    {
        id: 1,
        src: service_img_1,
        service_name: "Application Security",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: 2,
        src: service_img_2,
        service_name: "Infrastructure Security",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: 3,
        src: service_img_3,
        service_name: "Cloud-Native Security",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: 4,
        src: service_img_4,
        service_name: "Network Security",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },

]